// extracted by mini-css-extract-plugin
export var standaloneTable = "_ih-0";
export var standaloneTableWithBodyFill = "_ih-1";
export var withExtraHeader = "_ih-2";